import "lazysizes";
import Contact from "./modules/contact";
import Select from './modules/select';

import billboard from "./modules/billboard";
import multipleItemCarousel from "./modules/multiple-item-carousel";

Contact.init();
Select.init();
billboard.init();
multipleItemCarousel.init();
